module.exports = __webpack_public_path__ + "static/media/new-fruit-logo.f0b08633.png";